import { EmptyArray } from "../domain/empty/model";
import { PaymentsRepositoryImplementation } from '../infrastructure/payments-repository-implementation';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new PaymentsRepositoryImplementation();
const CACHE_PREFIX = 'payments';

async function getPayMethods(uid: string, cid: string | null) {
    try {
        const cacheKey = `${CACHE_PREFIX}-methods-${uid}-${cid}`;
        const cached = cacheManager.getItem(cacheKey);

        if (cached) {
            return cached;
        }

        const response = await repo.getPayMethods(uid, cid).toPromise();
        if (!response) return EmptyArray;
        const data = response.data;

        if (data.length === 0) {
            return EmptyArray;
        }

        cacheManager.setItem(cacheKey, data);
        return data;
    } catch (error) {
        console.log(error);
        return EmptyArray;
    }
}

async function processPayment(data: any) {
    const result = await repo.create(data).toPromise();
    if (!result) throw new Error("No response from payment creation");
    return result.data;
}

async function cancelSell(data: any) {
    const response = await repo.cancel(data).toPromise();
    if (!response) throw new Error("No response from payment cancellation");
    return response.data;
}

async function printSell(prefix: string, number: string) {
    const response = await repo.sell_print(prefix, number).toPromise();
    if (!response) throw new Error("No response from print request");
    return response.data;
}

async function showInvoicePDF(cufe: string) {
    const response = await repo.show_pdf(cufe).toPromise();
    if (!response) throw new Error("No response from show invoice pdf request");
    return response.data;
}

async function syncSell(bill_id: number | string) {
    const response = await repo.sync_sell(bill_id).toPromise();
    if (!response) throw new Error("No response from sync sell request");
    return response.data;
}

export { getPayMethods, processPayment, printSell, cancelSell, showInvoicePDF, syncSell }
